import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect as RouterRedirect } from 'react-router';

class Redirect extends PureComponent {
  render() {
    const { to, ...rest } = this.props;

    if (/^https?:\/\//.test(to) || /^mailto:/.test(to) || /^tel:/.test(to)) {
      if (typeof window !== 'undefined') {
        window.location = to;
        return;
      }
    }

    return <RouterRedirect to={to} {...rest} />;
  }
}

Redirect.propTypes = {
  to: PropTypes.string
};

export default Redirect;
